import { render, staticRenderFns } from "./Tippy.vue?vue&type=template&id=6abc2b59"
import script from "./Tippy.vue?vue&type=script&lang=js"
export * from "./Tippy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6abc2b59')) {
      api.createRecord('6abc2b59', component.options)
    } else {
      api.reload('6abc2b59', component.options)
    }
    module.hot.accept("./Tippy.vue?vue&type=template&id=6abc2b59", function () {
      api.rerender('6abc2b59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tippy/Tippy.vue"
export default component.exports